'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.secondsBefore;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/secondsBefore.js
// module id = 737
// module chunks = 0